var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2fbeee",
  d: "M27.778 28.8H12.222V16.7h15.556zm0-17.6h-1.111V9h-2.223v2.2h-8.888V9h-2.223v2.2h-1.11A2.21 2.21 0 0 0 10 13.4v15.4c0 .583.234 1.143.65 1.556.418.412.983.644 1.572.644h15.556c.59 0 1.154-.232 1.571-.644S30 29.383 30 28.8V13.4c0-.584-.234-1.143-.65-1.556a2.23 2.23 0 0 0-1.572-.644m-2.745 8.866L23.856 18.9l-5.423 5.368-2.355-2.332-1.178 1.166 3.533 3.498z"
})));
export default SvgCalendarCheck;